var map = {
	"./adaptability.png": 18857,
	"./compassion.png": 92521,
	"./contentment.png": 4044,
	"./cooperation.png": 64830,
	"./courage.png": 74687,
	"./courtesy.png": 81937,
	"./creativity.png": 28021,
	"./curiosity.png": 340,
	"./empathy.png": 49687,
	"./family.png": 46691,
	"./forgiveness.png": 27116,
	"./friendship.png": 74933,
	"./generosity.png": 31080,
	"./gratitude.png": 74418,
	"./green.png": 45322,
	"./grit.png": 32299,
	"./healthy_life.png": 63447,
	"./honor.png": 70147,
	"./integrity.png": 782,
	"./kindness.png": 28992,
	"./leadership.png": 93626,
	"./mindfulness.png": 14327,
	"./moderation.png": 58923,
	"./optimism.png": 59173,
	"./organization.png": 44126,
	"./patience.png": 2138,
	"./perseverance.png": 71014,
	"./punctuality.png": 51121,
	"./purple.png": 38757,
	"./red.png": 49198,
	"./resilience.png": 44388,
	"./resourcefulness.png": 93067,
	"./respect.png": 96685,
	"./responsibility.png": 22889,
	"./self_control.png": 27731,
	"./self_discipline.png": 46804,
	"./spirituality.png": 54662,
	"./teamwork.png": 74359,
	"./tolerance.png": 81750,
	"./values-scenario.png": 78538,
	"./values.png": 95593,
	"./yellow.png": 16139
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32404;